export const PageNotFound = () => {
  return (<div>
    <h1>Page Not Found</h1>
  </div>)
}
